module.exports = __webpack_public_path__ + "static/media/icon-edit-blue.63511f95.svg";